// Compare calendar dates in the event's timezone, not the visitor's timezone.
export const brusselsToday = (now = new Date()) => new Intl.DateTimeFormat('sv-SE', {
  timeZone: 'Europe/Brussels', year: 'numeric', month: '2-digit', day: '2-digit',
}).format(now);

export const upcomingEvents = (events, today = brusselsToday()) => (Array.isArray(events) ? events : [])
  .filter(event => {
    if (!event || !['upcoming', 'announced', 'sold_out'].includes(event.status)) return false;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(event.date || '')) return false;
    const parsed = new Date(`${event.date}T12:00:00Z`);
    return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === event.date && event.date >= today;
  })
  .sort((a, b) => a.date.localeCompare(b.date) || (a.time || '').localeCompare(b.time || ''));

export const eventTicketUrl = event => {
  if (!event || event.status !== 'upcoming') return null;
  try {
    const url = new URL(event.xceed_url);
    return ['https:', 'http:'].includes(url.protocol) ? url.href : null;
  } catch { return null; }
};
